/* nl-autoplay-video — muted looping clips that play while on screen, with a pause control.

   Root:    [data-nl-video]                      wraps one <video> and, optionally, its toggle
   Video:   <video muted loop playsinline>       inside the root; no autoplay attribute — this module
                                                 starts it, so reduced-motion readers never get a clip playing
   Toggle:  <button data-nl-video-toggle>        inside the root; aria-pressed="true" while paused
            data-nl-label-pause="Pause video"    accessible name while playing
            data-nl-label-play="Play video"      accessible name while paused
   Behaviour: plays only while at least 40% of the clip is in view (pauses off-screen). A reader who
              pauses a clip keeps it paused. prefers-reduced-motion: nothing autoplays — the clip stays on
              its poster until the reader presses play.
   Lifecycle: re-inits on shopify:section:load, tears down on :unload. */
(function () {
  var instances = {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.__nlVideo) return;
    var video = root.querySelector('video');
    if (!video) return;
    var toggle = root.querySelector('[data-nl-video-toggle]');
    var section = root.closest('[id^="shopify-section-"]');
    var userPaused = !!(reduce && reduce.matches);
    var visible = false;
    var observer = null;

    video.muted = true;

    function label() {
      if (!toggle) return;
      var paused = video.paused;
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      var text = paused ? toggle.getAttribute('data-nl-label-play') : toggle.getAttribute('data-nl-label-pause');
      if (text) toggle.setAttribute('aria-label', text);
    }
    function play() {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    function sync() {
      if (visible && !userPaused) play(); else video.pause();
    }
    function onToggle() {
      userPaused = !video.paused;
      if (userPaused) video.pause(); else play();
    }

    video.addEventListener('play', label);
    video.addEventListener('pause', label);
    if (toggle) toggle.addEventListener('click', onToggle);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        visible = entries[entries.length - 1].isIntersecting;
        sync();
      }, { threshold: 0.4 });
      observer.observe(video);
    } else {
      visible = true;
      sync();
    }
    label();

    root.__nlVideo = true;
    var key = (section ? section.id : 'x') + ':' + [].indexOf.call(document.querySelectorAll('[data-nl-video]'), root);
    instances[key] = function () {
      if (observer) observer.disconnect();
      video.removeEventListener('play', label);
      video.removeEventListener('pause', label);
      if (toggle) toggle.removeEventListener('click', onToggle);
      delete root.__nlVideo;
    };
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-nl-video]'), init);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var prefix = (e.target.id || 'x') + ':';
    Object.keys(instances).forEach(function (k) {
      if (k.indexOf(prefix) === 0) { instances[k](); delete instances[k]; }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
